import { toast } from "react-toastify";
import {
  addVehiclesFailure,
  addVehicleStart,
  addVehicleSuccess,
  deleteVehicleFailure,
  deleteVehicleStart,
  deleteVehicleSuccess,
  editVehicleFailure,
  editVehicleStart,
  editVehicleSuccess,
  fetchVehiclesFailure,
  fetchVehiclesStart,
  fetchVehiclesSuccess,
  vehicleActionFailure,
  vehicleActionStart,
  vehicleActionSuccess,
} from "./reducer";
import { getSupplierListService } from "../../Services/SupplierService";
import {
  addVehicleService,
  deleteVehicleService,
  editVehicleService,
  getVehicleListService,
  vehicleActionService,
} from "../../Services/VehicleMasterService";

//thunk for fetch the category list
export const fetchVehiclesList =
  (params = {}) =>
  async (dispatch) => {
    try {
      dispatch(fetchVehiclesStart());
      const response = await getVehicleListService(params);

      if (params.isPagination === 0) {
        // const currentPagination = getState().MealCategory.pagination;
        dispatch(
          fetchVehiclesSuccess({
            vehicles: response.data, // full list
            // pagination: currentPagination,
            pagination: {
              totalPages: 1,
              totalElements: response.data.length,
              currentPage: 0,
              pageSize: response.data.length,
              isLastPage: true,
              isFirstPage: true,
            },
          }),
        );
      } else if (response?.data?.content) {
        dispatch(
          fetchVehiclesSuccess({
            vehicles: response.data.content,
            pagination: {
              totalPages: response.data.totalPages,
              totalElements: response.data.totalElements,
              currentPage: response.data.pageable.pageNumber,
              pageSize: response.data.pageable.pageSize,
              isLastPage: response.data.last,
              isFirstPage: response.data.first,
            },
          }),
        );
      } else {
        dispatch(fetchVehiclesFailure("No data found"));
      }
    } catch (error) {
      dispatch(fetchVehiclesFailure(error));
    }
  };

//thunk for the addig the category

export const addVehicle = (requestParam) => async (dispatch) => {
  try {
    dispatch(addVehicleStart());

    const response = await addVehicleService(requestParam);

    if (response?.success) {
      toast.success(response.message);
      dispatch(addVehicleSuccess(response));
    } else {
      toast.error("Something went wrong ");
      dispatch(addVehiclesFailure("Failed to add Vehicle"));
    }
  } catch (error) {
    toast.error(error);

    dispatch(addVehiclesFailure(error));
  }
};

// //this is the thunk for delete the category
export const deleteVehicle = (vehicleId) => async (dispatch) => {
  try {
    dispatch(deleteVehicleStart());

    const response = await deleteVehicleService(vehicleId);

    if (response?.success) {
      toast.success(response.message);
      dispatch(deleteVehicleSuccess(vehicleId));
    } else {
      toast.error("Failed to delete supplier");
      dispatch(deleteVehicleFailure("Delete failed"));
    }
  } catch (error) {
    toast.error(error);
    dispatch(deleteVehicleFailure(error));
  }
};

// // //this tunk for the edit meal category
export const editVehicle = (requestParam) => async (dispatch) => {
  try {
    dispatch(editVehicleStart());

    const response = await editVehicleService(requestParam);

    if (response?.success) {
      toast.success(response.message);
      dispatch(editVehicleSuccess(response));
    } else {
      dispatch(editVehicleFailure("Failed to update vehicle"));
    }
  } catch (error) {
    toast.error(error);
    dispatch(editVehicleFailure(error));
  }
};

export const vehicleAction = (vehicleId, isActive) => async (dispatch) => {
  try {
    dispatch(vehicleActionStart());

    const response = await vehicleActionService(vehicleId, isActive);

    if (response?.success) {
      toast.success(response.message);

      dispatch(
        vehicleActionSuccess({
          id: vehicleId,
          isActive,
        }),
      );
    } else {
      toast.error(response?.message);

      dispatch(vehicleActionFailure("Failed"));
    }
  } catch (error) {
    console.log("error", error);
    toast.error(error);

    dispatch(vehicleActionFailure("something went wrong"));
  }
};

// //this thunk is for the get by id
// export const fetchMealCategoryById = (id) => async (dispatch) => {
//   try {
//     dispatch(getCategoryByIdStart());
//     const response = await getCategoryByIdService(id);
//     if (response?.data) {
//       dispatch(getCategoryByIdSuccess(response.data));
//     } else {
//       dispatch(getCategoryByIdFailure("No category found"));
//     }
//   } catch (error) {
//     toast.error(error);
//     dispatch(getCategoryByIdFailure(error));
//   }
// };
